"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetaInfo = void 0;
function getMetaInfo(data, options) {
    var _a;
    const { pageViewData, featureToggleData } = data;
    const { exposeFeatures, version = process.env.VERSION } = options;
    if (typeof pageViewData === 'undefined') {
        // eslint-disable-next-line no-console
        console.error(`pageViewData is undefined. pageView page prop is not priveded`);
    }
    const metaInfo = {
        meta: {
            language: (_a = pageViewData === null || pageViewData === void 0 ? void 0 : pageViewData.language) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
            version,
        },
    };
    if (exposeFeatures) {
        metaInfo.meta.features = Object.entries(featureToggleData.config).reduce((accumulator, [featureName, featureConfig]) => {
            let featureToAdd;
            if (!featureConfig.enabled) {
                return accumulator;
            }
            if (featureConfig.variant.enabled) {
                featureToAdd = `${featureName}:${featureConfig.variant.name}`;
            }
            else {
                featureToAdd = featureName;
            }
            return [...accumulator, featureToAdd];
        }, []);
    }
    return metaInfo;
}
exports.getMetaInfo = getMetaInfo;
//# sourceMappingURL=getMetaInfo.js.map